/**
 * Format a date string to MM/DD/YY h:mmam/pm format
 * @param dateString ISO date string or Date object
 * @returns Formatted date string (e.g., "1/19/25 4:36pm")
 */
export const formatDate = (dateString: string | Date): string => {
  const date = new Date(dateString);

  // Check if date is valid
  if (isNaN(date.getTime())) {
    return "Invalid date";
  }

  const month = date.getMonth() + 1; // getMonth() returns 0-11
  const day = date.getDate();
  const year = date.getFullYear().toString().slice(-2); // Last 2 digits of year

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";

  // Convert 24h to 12h format
  hours = hours % 12;
  hours = hours ? hours : 12; // 0 should be displayed as 12

  return `${month}/${day}/${year} ${hours}:${minutes}${ampm}`;
};
